import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "src/firebase";
import { Repository } from "src/firebase/firestore/repository";
import { AiSessionMessage } from "../types/ai-session.entity";

class AISessionMessageRepository extends Repository<AiSessionMessage> {
  constructor(private readonly sessionId: string) {
    super("ai_sessions");
  }

  async findAllBySessionId(limitCount: number = 1000): Promise<(AiSessionMessage & { id: string })[]> {
    const messagesRef = collection(db, "ai_sessions", this.sessionId, "messages");
    const messagesQuery = query(messagesRef, orderBy("timestamp", "asc"), limit(limitCount));
    const snapshot = await getDocs(messagesQuery);
    return snapshot.docs.map((doc) => this.map(doc));
  }
}

export const createAISessionMessageRepository = (sessionId: string) => new AISessionMessageRepository(sessionId);
